import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";
import { articles, faqs } from "@/mocks/articles";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import ChannelBoard from "./components/ChannelBoard";
import DeepDigSection from "./components/DeepDigSection";
import FaqSection from "./components/FaqSection";
import AboutTeaser from "./components/AboutTeaser";

const site = "https://immaple.cn";
const top5 = [...articles].sort((a, b) => b.views - a.views).slice(0, 5);

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "在线吃瓜",
      description: "深度娱乐观察内容站，聚焦明星动态、小道消息、未删细节与隐藏线索的挖掘。",
      url: site,
    },
    {
      "@type": "WebSite",
      name: "在线吃瓜",
      url: site,
      inLanguage: "zh-CN",
      description: "在线吃瓜 · 未删细节隐藏线索 · 小道消息边角料深度挖掘",
    },
    {
      "@type": "CollectionPage",
      name: "在线吃瓜 · 首页今日热度榜单",
      url: site,
      about: "娱乐圈深度观察与热度排行",
    },
    {
      "@type": "ItemList",
      name: "今日热度榜单 Top5",
      itemListElement: top5.map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: a.title,
        url: `${site}/article/${a.id}`,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <Seo
        title="在线吃瓜 - 未删细节隐藏线索 · 小道消息边角料深度吃瓜"
        description="在线吃瓜，专注娱乐八卦深度观察。独家视角挖掘未删细节与隐藏线索，从边角料、小道消息到补充爆料层层展开，看明星动态、热搜内幕，让每个瓜都比旁人吃得更透更深。"
        keywords="在线吃瓜,在线吃瓜未删细节,在线吃瓜隐藏线索,在线吃瓜小道消息,在线吃瓜边角料,在线吃瓜深度挖掘"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <HeroSection />
          <TrendingSection />
          <ChannelBoard />
          <DeepDigSection />
          <FaqSection />
          <AboutTeaser />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}